/**
 * /settings/resources — SPEC-14 Resources (account scope).
 *
 * Gated on VITE_RESOURCES_HUB, which is baked at UI build time and defaults to
 * false. With the flag off the route redirects to Settings rather than
 * rendering an empty shell: a page that exists but shows nothing is read as a
 * broken page, and this one has three server flags of its own that could each
 * be the reason.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../../env';

export const Route = createFileRoute('/_authenticated/settings/resources')({
  beforeLoad: () => {
    if (!env.VITE_RESOURCES_HUB) {
      throw redirect({ to: '/settings/profile', replace: true });
    }
  },
});
